import styled from 'styled-components';

export const Container = styled.div`
  .link_acervo {
    display: -webkit-box;
    -webkit-line-clamp: 5;
    overflow: hidden;
    -webkit-box-orient: vertical;

    &:link,
    &:visited {
      color: ${(props) => props.theme.$black};
    }

    &:hover {
      color: ${(props) => props.theme.$primary};
    }

    p {
      margin: 0px;
    }
  }

  .img-card {
    height: 8rem;
  }

  .breadcrumb {
    display: flex;
    flex-wrap: wrap;
    padding: 0.56rem 1.13rem;
    margin-bottom: 1rem;
    list-style: none;
    background-color: transparent;
    border-radius: 0.25rem;
  }
  .breadcrumb.breadcrumb-custom .breadcrumb-item {
    font-size: 0.875rem;
    background: #eeeeee;
    padding: 0.56rem 10px;
    color: #000;
    display: inline-block;
  }
  .breadcrumb-item + .breadcrumb-item::before {
    display: inline-block;
    padding-right: 0.5rem;
    color: #6c757d;
  }

  .breadcrumb.breadcrumb-custom .breadcrumb-item a::before {
    right: -22px;
    z-index: 3;
    border-left-color: #eeeeee;
    border-left-style: solid;
    border-left-width: 12px;
  }

  .breadcrumb.breadcrumb-custom .breadcrumb-item a::after {
    border-top: 21px solid transparent;
    border-bottom: 22px solid transparent;
    border-left: 12px solid #ffffff;
    top: -9px;
    right: -23px;
  }

  .breadcrumb.breadcrumb-custom .breadcrumb-item a {
    position: relative;
    color: inherit;
    border: 1px solid #eee;
    display: inline-block;
    vertical-align: top;
    cursor: default;
  }

  .breadcrumb.breadcrumb-custom .breadcrumb-item a::before,
  .breadcrumb.breadcrumb-custom .breadcrumb-item a::after {
    position: absolute;
    top: -9px;
    width: 0;
    height: 0;
    content: '';
    border-top: 21px solid transparent;
    border-bottom: 21px solid transparent;
  }

  .breadcrumb.breadcrumb-custom .breadcrumb-item::before {
    content: '';
  }

  ol {
    margin-left: -14px;
  }
`;
